/* eslint-disable array-callback-return */
import * as React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import AddressSearch from "react-loqate";
// to use the default styles for the default components
import "react-loqate/dist/react-loqate.cjs.development.css";

interface PostalCodeProps {
  handleSubmitAddress: (address: any) => void;
}

const PostalCode = (handleSubmitData: any) => {
  const handleSubmitAddress = handleSubmitData.handleSubmitAddress;
  const handleSubmit = async (address: any) => {
    const postCode = address?.PostalCode;
    handleSubmitAddress({
      country: address?.CountryName,
      town: address?.City,
      address1: address?.Line1 ? address?.Line1 + ", " + address?.Line2 : "",
      address2: address?.Line3,
      postCode: postCode,
    });
    // setPostalCode(postCode ?? postalCode);
  };
  const CustomInput = (props: any): JSX.Element => {
    return (
      <TextField
        inputRef={handleSubmitData.FocusAddressInput}
        {...props}
        label="Type the address/post code to search..."
        autocomplete="chrome-off"
        fullWidth
      />
    );
  };

  return (
    <Box position={"relative"} tabIndex={0}>
      <AddressSearch
        locale="en-GB"
        apiKey="FD86-NN58-EN44-PR51"
        countries={["GB"]}
        components={{
          Input: CustomInput,
        }}
        onSelect={(address) => handleSubmit(address)}
        inline
        debounce={100}
        classes={{ list: "styled-list" }}
        className="placeholder-style"
      />
    </Box>
  );
};

export { PostalCode };
